/**
 * НАЗНАЧЕНИЕ: Конфигурация Redux store для глобального состояния
 * ОПИСАНИЕ: Центральное хранилище состояния приложения с редьюсерами:
 * - auth - состояние аутентификации (токены, пользователь)
 * - slide - состояние отдельного слайда (для просмотра)
 * - slides - состояние списка слайдов (таблица, фильтры, выбранные)
 * ГИДРАТАЦИЯ: Восстановление состояния из localStorage при загрузке
 * MIDDLEWARE: Redux Toolkit с дефолтными middleware для разработки
 */
import {configureStore} from "@reduxjs/toolkit";
import authReducer from "./redux/auth-reducer";
import slideReducer from "./redux/slide-reducer";
import slidesReducer from "./redux/slides-reducer"
import {rehydrateStore} from "./auth/middleware";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        slide: slideReducer,
        slides: slidesReducer,
    },
    preloadedState: rehydrateStore(),

});
